// Textfield
// eg. Talent Name
// 

JLM.MD.Textfield = function( fieldset ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let input;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.value = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		const legend = $('legend', fieldset);
		input = $('input[type="email"], input[type="text"], input[type="tel"], textarea', fieldset);
		const but_clear = $('button[data-action="clear"]', fieldset);
		
		// Events
		if ( legend.length ) legend.on('click', INSTANCE.focus);
		input.on('keydown change paste', onChange);
		but_clear.on('click', onClickClear);
	}
	
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Value change
	// 
	function onChange() {
		setTimeout(function() {
			let value = input.val();
			if ( value !== INSTANCE.value ) {
				INSTANCE.value = $.trim( value );
				if ( INSTANCE.value ) {
					fieldset.attr('data-filled', '1');
				} else {
					fieldset.attr('data-filled', '');
				}
				fieldset.attr('data-error', '');
				INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
			}
		}, 10);
	}
	
	
	// Event: Clear textfield
	// 
	function onClickClear() {
		input.val('');
		onChange();
		INSTANCE.focus();
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Set focus on input field
	// 
	INSTANCE.focus = function( select_all ) {
		input.focus();
		if ( select_all ) input.select();
	};
	
	
	// Highlight field for error
	// 
	INSTANCE.showError = function() {
		setTimeout(function() {
			fieldset.attr('data-error', '1');
		}, 10);
	};
	
	
	// Update value directly
	// 
	INSTANCE.setValue = function( value ) {
		input.val( value );
		onChange();
	};
	INSTANCE.clear = function() {
		input.val('');
		onChange();
	};
	
	
	// Disable
	// 
	INSTANCE.disable = function() {
		input.prop('disabled', true);
	};
	INSTANCE.enable = function() {
		input.prop('disabled', false);
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};